/**
 * 通用默认值
 */
/** 默认时区 */
export const DEFAULT_TIMEZONE = 'Asia/Shanghai';
/** 系统用户标识 */
export const SYSTEM_USER_ID = 'system';
/** 自动更新检查间隔（毫秒） */
export const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000;
/** bcrypt salt rounds */
export const BCRYPT_SALT_ROUNDS = 12;
/**
 * 新建用户初始密码（首次登录强制修改）
 * 优先读 NEXT_PUBLIC_DEFAULT_NEW_USER_PASSWORD / DEFAULT_NEW_USER_PASSWORD env，
 * 仅在 env 未配置时回退到内置占位符。生产部署必须在 .env 中显式设置。
 */
const ENV_PASSWORD = (typeof process !== 'undefined' && process.env
    ? process.env.NEXT_PUBLIC_DEFAULT_NEW_USER_PASSWORD ?? process.env.DEFAULT_NEW_USER_PASSWORD
    : undefined) ?? '';
export const DEFAULT_NEW_USER_PASSWORD = ENV_PASSWORD.length >= 8 ? ENV_PASSWORD : 'ChangeMe!Now';
/** 分页默认值 */
export const DEFAULT_PAGE_SIZE = 20;
/** 数据刷新间隔（毫秒） */
export const DATA_REFRESH_INTERVAL_MS = 30000;
